module.exports = __webpack_public_path__ + "img/overview.f1ebe290.svg";